import React from 'react';
import { Typography } from '@material-ui/core';
import parse from 'html-react-parser';
import NumberFormat from 'react-number-format';
import { CATALOGUE_LINK_PREVIEW_LIMIT } from 'src/views/OmniChannel/constants/catalogue';
import type { TCatalogueDocumentItemProps } from 'src/views/OmniChannel/types/catalogue';
import {
    getCatalogueMediaUrl,
    limitCatalogueCharacters,
} from 'src/views/OmniChannel/utils/catalogue';
import { DocumentsGridItem } from '../documents';
import { useDocumentsGridItemStyles } from '../documents/documentsGridStyles';

export const CatalogueDocumentItem = ({
    document,
    onSelect,
}: TCatalogueDocumentItemProps) => {
    const classes = useDocumentsGridItemStyles();

    const getURL = (text: string) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, (url) => {
            return `<a style="text-decoration: none; font-weight: 600; color: inherit;" href="${url}" target="_blank" rel="noopener noreferrer">${limitCatalogueCharacters(
                url,
                CATALOGUE_LINK_PREVIEW_LIMIT
            )}</a>`;
        });
    };

    const hasModel = Boolean(document.model?.trim());
    const hasPrice = Boolean(document.price?.trim());
    const hasDescription = Boolean(document.description?.trim());
    const hasLink = Boolean(document.link?.trim());
    const hasImage = Boolean(document.file?.trim());

    const title = (
        <>
            {hasModel && <b>{document.model}</b>}
            {hasModel && hasPrice && ' '}
            {hasPrice && (
                <NumberFormat
                    value={document.price}
                    displayType="text"
                    thousandSeparator
                    prefix="$"
                />
            )}
        </>
    );

    const footer = (
        <>
            {hasDescription && (
                <Typography
                    color="inherit"
                    variant="body1"
                    className={classes.secondaryText}
                    style={{ marginTop: hasModel || hasPrice ? 4 : 0 }}
                >
                    {document.description}
                </Typography>
            )}
            {hasLink && (
                <Typography
                    color="inherit"
                    variant="body1"
                    className={classes.secondaryText}
                    style={{
                        marginTop:
                            hasModel || hasPrice || hasDescription ? 4 : 0,
                    }}
                >
                    {parse(getURL(document.link!))}
                </Typography>
            )}
        </>
    );

    return (
        <DocumentsGridItem
            mediaUrl={hasImage ? getCatalogueMediaUrl(document.file) : undefined}
            mediaAlt={document.model || 'catalogue-item'}
            title={hasModel || hasPrice ? title : undefined}
            footer={hasDescription || hasLink ? footer : undefined}
            onClick={() => onSelect(document)}
        />
    );
};
